// Thin wrapper over Razorpay Checkout.js.
// checkout.js is loaded via <script> in index.html, so window.Razorpay is global.
//
// openCheckout(opts) returns a Promise that:
//   resolves with payment payload on success
//   rejects with { reason: "dismissed" | "failed", error? } otherwise

export function openCheckout({
  keyId,
  subscriptionId,
  amount,
  currency = "INR",
  name = "Bizzfly Reports",
  description = "Subscription",
  prefill = {},
  theme = { color: "#7c3aed" },
}) {
  return new Promise((resolve, reject) => {
    if (!window.Razorpay) {
      return reject(new Error("Razorpay SDK not loaded"));
    }

    const rzp = new window.Razorpay({
      key: keyId,
      subscription_id: subscriptionId,
      amount,
      currency,
      name,
      description,
      prefill,
      theme,
      handler: (response) => {
        resolve({
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_subscription_id: response.razorpay_subscription_id,
          razorpay_signature: response.razorpay_signature,
        });
      },
      modal: {
        ondismiss: () => reject({ reason: "dismissed" }),
      },
    });

    rzp.on("payment.failed", (resp) =>
      reject({ reason: "failed", error: resp.error }),
    );

    rzp.open();
  });
}
